import { gql } from '@apollo/client';

/**
 * The signed-in distributor, resolved from the `company` claim.
 *
 * Every other query on this page is scoped by the numeric id this returns; the
 * claim only carries the uuid.
 */
export const DISTRIBUTOR_QUERY = gql`
  query DashboardDistributor($uuid: ID!) {
    distributorByUuid(uuid: $uuid) {
      id
      uuid
      name
      emailAddress
      phoneNumber
      logoUrl
    }
  }
`;

/**
 * The distributor's most recent quotations, plus how many they have in total.
 *
 * `revisions { options { updatedAt } }` is how the quote list screen works out
 * when a quotation last changed — the quote row's own `updatedAt` does not move
 * when an option is re-priced. Read the same way here so the two screens never
 * disagree about which quote was touched last.
 */
export const RECENT_QUOTES_QUERY = gql`
  query DashboardRecentQuotes($distributorId: Int, $limit: Int) {
    quotes(filter: { distributorId: $distributorId }, orderBy: updatedAt_DESC, limit: $limit) {
      id
      uuid
      description
      type
      createdAt
      revisions {
        options {
          updatedAt
        }
      }
    }
    quoteSummary(filter: { distributorId: $distributorId }) {
      count
    }
  }
`;

/** Notices from Hi-Level — the same rows the bell in the menu bar counts. */
export const NOTIFICATIONS_QUERY = gql`
  query DashboardNotifications($today: DateTime!) {
    notifications(filter: { expiresAt_gte: $today }, orderBy: updatedAt_DESC) {
      subject
      description
      updatedAt
    }
  }
`;
